// Shimmering block shown in place of a patient card while its data loads.
// qampo-ui-library only offers a spinner-style `Loader`, so the drawers share
// this skeleton instead.
import styles from './LoadingPlaceholder.module.css';

export const LoadingPlaceholder = () => <div className={styles.loadingPlaceholder} />;
